export const projects = [
  {
    id: 0,
    title: 'Anushesh Portfolio',
    desc: 'A responsive developer portfolio showcasing projects, skills, and contact information.',
    tags: ['React', 'JavaScript', 'CSS', 'Responsive Design'],
    links: { code: 'https://github.com/urstrulyanushesh/Anushesh-portfolio' },
    color: '#f3d34a',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/Anushesh-portfolio',
  },
  {
    id: 1,
    title: 'Real-Time Chat Application',
    desc: 'Full-stack messaging with live presence, typing indicators, and group conversations.',
    tags: ['React', 'Node.js', 'Express', 'MongoDB', 'Socket.IO', 'JWT'],
    links: { code: 'https://github.com/urstrulyanushesh/Real-Time-Chat-Application' },
    color: '#c778dd',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/Flappy-Butterfly',
  },
  {
    id: 2,
    title: 'Emotion Aware AI ChatBot',
    desc: 'Context-aware conversations powered by emotion classification and language APIs.',
    tags: ['Python', 'Flask', 'Scikit-Learn', 'Pandas', 'OpenAI'],
    links: { code: 'https://github.com/urstrulyanushesh/Emotion_ChatBot' },
    color: '#4ade80',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/Flappy-Butterfly',
  },
  {
    id: 3,
    title: 'Employee Management System',
    desc: 'Java desktop application for employee records, CRUD workflows, and persistent data.',
    tags: ['Java', 'OOP', 'CRUD', 'SQL', 'Desktop Application'],
    links: { code: 'https://github.com/urstrulyanushesh/Employee-Management-System' },
    color: '#7c3aed',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/Flappy-Butterfly',
  },
  {
    id: 4,
    title: 'Nike Shoes Brand',
    desc: 'A responsive JavaScript brand experience for browsing Nike shoes.',
    tags: ['JavaScript', 'HTML', 'CSS', 'Vite'],
    links: { code: 'https://github.com/urstrulyanushesh/Nike_Shoes_Brand' },
    color: '#20c4c7',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/Nike_Shoes_Brand',
  },
  {
    id: 5,
    title: 'Flappy Butterfly',
    desc: 'A Java game project inspired by the classic side-scrolling arcade format.',
    tags: ['Java', 'Game Development'],
    links: { code: 'https://github.com/urstrulyanushesh/Flappy-Butterfly' },
    color: '#f06aa8',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/Flappy-Butterfly',
  },
  {
    id: 6,
    title: 'PortFellow',
    desc: 'A JavaScript project exploring portfolio-focused web development.',
    tags: ['JavaScript', 'Web Development'],
    links: { code: 'https://github.com/urstrulyanushesh/PortFellow' },
    color: '#f3d34a',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/PortFellow',
  },
  {
    id: 7,
    title: 'Login Page',
    desc: 'A static login page built with semantic HTML and custom CSS styling.',
    tags: ['HTML', 'CSS'],
    links: { code: 'https://github.com/urstrulyanushesh/Login-Page' },
    color: '#ff5c35',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/Login-Page',
  },
  {
    id: 8,
    title: 'Hospital Management System',
    desc: 'A C programming project for managing hospital records and workflows.',
    tags: ['C', 'Data Management'],
    links: { code: 'https://github.com/urstrulyanushesh/Hospital_Management_System_In_C' },
    color: '#20c4c7',
    image: 'https://opengraph.githubassets.com/1/urstrulyanushesh/Hospital_Management_System_In_C',
  },
];

export const skills = {
  Languages: ['Python', 'JavaScript (ES6+)', 'Java', 'C++', 'C', 'PHP', 'HTML5', 'CSS3'],
  Frameworks: ['React.js', 'Node.js', 'Express.js', 'Flask', 'Django', 'Scikit-Learn', 'Pandas'],
  Databases: ['MongoDB', 'MySQL', 'MariaDB', 'SQLite'],
  'Web Tech': ['REST APIs', 'JSON', 'WebSockets'],
  Tools: ['Git', 'GitHub', 'Postman', 'Figma', 'VS Code', 'Linux', 'Render', 'VirtualBox'],
  Domains: ['Web Scraping', 'Automation', 'SEO', 'Cybersecurity Fundamentals'],
};
